module.exports = __webpack_public_path__ + "img/smilingFaces_loader.2fc3e564.svg";